/**
 * Проверяет является ли переданное значение boolean.
 *
 * @param value Значение, которое нужно проверить.
 * @returns true, если переданное значение является boolean, иначе false.
 * @example
 * ```typescript
 * import { isBoolean } from '@direct-frontend/stdlib';
 *
 * isBoolean(false); // true
 * isBoolean('true'); // false
 * ```
 */
export function isBoolean(value) {
    return typeof value === 'boolean';
}
